import { F as e, R as t, _ as n, h as r, p as i, rt as a, t as o, v as s, w as c } from "./_plugin-vue_export-helper-CTQVpqU-.js";
//#region src/webcomponents/common/poi-design-system/Feedback.ce.vue?vue&type=script&setup=true&lang.ts
var l = {
	"aria-live": "polite",
	class: "feedback-container"
}, u = {
	key: 0,
	class: "feedback-container__title"
}, d = /*#__PURE__*/ o(/* @__PURE__ */ c({
	__name: "Feedback.ce",
	props: {
		displayFeedback: { type: Boolean },
		contentOnly: { type: Boolean }
	},
	setup(o) {
		return (c, d) => (e(), s("div", l, [o.displayFeedback ? (e(), s(i, { key: 0 }, [o.contentOnly ? n("", !0) : (e(), s("p", u, [t(c.$slots, "icon"), t(c.$slots, "title")])), r("p", { class: a(["feedback-container__content", { "feedback-container__content--only": o.contentOnly }]) }, [t(c.$slots, "content")], 2)], 64)) : n("", !0)]));
	}
}), [["styles", [".feedback-container{width:100%;font-size:.875em}.feedback-container__title{color:#fff;background:#155dfc;border-radius:8px 8px 0 0;justify-content:center;align-items:center;gap:8px;width:fit-content;margin:0;padding:4px 8px;font-weight:700;display:flex}.feedback-container__title svg{width:16px;height:16px}.feedback-container__content{background:#eaf1ff;border-radius:0 8px 8px;margin:0;padding:8px}.feedback-container__content--only{border-radius:8px}"]]]), f = {
	viewBox: "0 0 16 16",
	fill: "none",
	"aria-hidden": "true"
}, p = ["stroke"], m = /* @__PURE__ */ c({
	__name: "Check.ce",
	props: { color: { type: String } },
	setup(t) {
		return (n, i) => (e(), s("svg", f, [r("path", {
			d: "\n        M 3, 8\n        L 7, 12\n        L 13, 4\n      ",
			stroke: t.color ? t.color : "#fff",
			"stroke-width": "1.5",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, 8, p)]));
	}
}), h = {
	viewBox: "0 0 16 16",
	fill: "none",
	"aria-hidden": "true"
}, g = ["stroke"], _ = /* @__PURE__ */ c({
	__name: "Cross.ce",
	props: { color: { type: String } },
	setup(t) {
		return (n, i) => (e(), s("svg", h, [r("path", {
			d: "\n        M 4, 4\n        L 12, 12\n        M 4, 12\n        L 12, 4\n      ",
			stroke: t.color ? t.color : "#fff",
			"stroke-width": "1.5",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, 8, g)]));
	}
});
//#endregion
export { m as n, d as r, _ as t };
